export class NodePageMicrosite extends DrupalBehavior {
  onContent(context) {
    const micrositeElement = context.querySelector('.header--secondary--wrap');
    /* istanbul ignore else - This is always true */
    if (micrositeElement) {
      this.resetSecondaryMenu = this.resetSecondaryMenu.bind(this);
      this.intersectionHandler = this.intersectionHandler.bind(this);
      this.sidebarNav = this.sidebarNav.bind(this);
      let mqlLarge = window.matchMedia('(max-width: 1199px)');
      let mql = window.matchMedia('(max-width: 991px)');

      this.sidebarNavElement = document.querySelector(
        '.interior-main-article--sidebar nav .sidebar-nav--content'
      );
      this.sidebarNavToggle = document.querySelector(
        '.interior-main-article--sidebar nav h2'
      );
      /* istanbul ignore next - No need to test an external library */
      mql.addEventListener('change', this.sidebarNav);
      this.sidebarNav(mql);

      this.sectionToggle = context.querySelector('.header--secondary--toggle');
      this.secondaryMenu = context.querySelector('.header--secondary--wrap');
      this.secondaryMenuDropdown = context.querySelector('.header--secondary');
      this.secondaryMenuItems = context.querySelectorAll(
        '.header--secondary a'
      );
      /* istanbul ignore next - No need to test an external library */
      mqlLarge.addEventListener('change', this.resetSecondaryMenu);
      this.resetSecondaryMenu(mqlLarge);

      var self = this;
      this.sectionToggle.addEventListener('click', function (e) {
        e.preventDefault();
        if (self.secondaryMenu.classList.contains('active')) {
          self.secondaryMenu.classList.remove('active');
          gsap.to(self.secondaryMenuDropdown, {
            duration: 0.5,
            ease: 'power4.out',
            height: 0,
            onComplete: function () {
              self.secondaryMenuDropdown.classList.add('inactive');
            },
          });
        } else {
          self.secondaryMenuDropdown.classList.remove('inactive');
          self.secondaryMenu.classList.add('active');
          gsap.to(self.secondaryMenuDropdown, {
            duration: 0.5,
            ease: 'power4.out',
            height: 'auto',
          });
        }
      });

      if (this.secondaryMenu.classList.contains('sticky')) {
        let io = new IntersectionObserver(this.intersectionHandler);
        let primaryNav = document.querySelector('.header-menu--primary');
        io.observe(primaryNav);
      }
    }
  }

  sidebarNav(mql) {
    if (mql.matches) {
      var self = this;
      if (self.sidebarNavToggle) {
        this.sidebarNavToggle.addEventListener('click', function (e) {
          self.sidebarNavToggle.classList.toggle('open');
          if (self.sidebarNavToggle.classList.contains('open')) {
            gsap.to(self.sidebarNavElement, {
              duration: 0.5,
              ease: 'power4.out',
              height: 'auto',
            });
          } else {
            gsap.to(self.sidebarNavElement, {
              duration: 0.5,
              ease: 'power4.out',
              height: 0,
            });
          }
        });
      }
    }
  }

  resetSecondaryMenu(mql) {
    if (mql.matches) {
      this.secondaryMenuDropdown.classList.add('inactive');
    } else {
      this.secondaryMenuDropdown.classList.remove('inactive');
    }
  }

  intersectionHandler(entries, observer) {
    var main = document.querySelector('main.main');
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.secondaryMenu.classList.remove('sticky-active');
        main.classList.remove('sticky-active');
      } else {
        this.secondaryMenu.classList.add('sticky-active');
        main.classList.add('sticky-active');
      }
    });
  }
}

DrupalBehavior.register('rush_theme.node_page', 'microsite', NodePageMicrosite);
